import { LotApiResponse } from "./LotMap.constants";

export function getAvailableLotContent(feature: LotApiResponse): string {
	const builderName = feature?.properties?.builder?.name;
	const src = `/wp-content/themes/hhh-teravalis/assets/images/available-lot.svg`;
	const alt = ``;

	const badge = `${builderName}`;
	const heading = `${feature.properties.lot.name}`;
	const body = `${feature.properties.lot.description}`;

	return `<hhds-card type="plans" modal="false">
    <hhds-image src="${src}" alt="${alt}" style="--image-aspect-ratio: 16/9; --image-object-fit: cover;" animate="true" slot="image"></hhds-image>
    <hhds-richtext style="
      --richtext-padding: var(--spacing-spacer-12);
      --richtext-padding-md: var(--spacing-spacer-16); 
      --richtext-display: block;
      flex: 1;
    ">
      <p style="--richtext-color: var(--color-primary-darkgreen);" class="uppercase uppercase--01" >${badge}</p>
      <h3 class="heading heading--01" >${heading}</h3>
      <p class="bodytext bodytext--01">${body}</p>
    </hhds-richtext>
  </hhds-card>`;
}

export function getPlanContent(apiResponse: LotApiResponse): string {
	const lotData = apiResponse.properties.lot;
	const src = lotData.src;

	const builderName = apiResponse.properties.builder.name;
	const alt = ``;
	const badge = `${builderName}`;
	const heading = lotData.name;
	const planData = apiResponse.properties.plan;
	const beds = planData.beds;
	const baths = planData.baths;
	const garage = planData.garages;
	const story = planData.stories;
	const sqft = planData.sq_ft;
	const price = planData.price;
	const body = lotData.description;

	const link = lotData.url;

	return `
  <hhds-card type="map">
    <hhds-image src="${src}" alt="${alt}" style="--image-aspect-ratio: 16/9; --image-object-fit: cover;" animate="true" slot="image"></hhds-image>
    ${getBadgesHTML(lotData)}
    <hhds-richtext style="--richtext-padding: var(--spacing-spacer-12); --richtext-padding-md: var(--spacing-spacer-16); --richtext-display: block; flex: 1;">
      <p style="--richtext-color: var(--color-primary-darkgreen);" class="uppercase uppercase--01">${badge}</p>
      <h3 class="heading heading--01">${heading}</h3>
      <p class="bodytext bodytext--01">${body}</p>
    </hhds-richtext>
    <hhds-home-info slot="home-info" type="lot" beds="${beds}" baths="${baths}" garage="${garage}" story="${story}" sqft="${sqft}" price="${price}"></hhds-home-info>
    <hhds-button slot="buttons" width="full" style="min-width: 100%;" href="${link}">SEE DETAILS</hhds-button>
  </hhds-card>`;
}

function getBadgesHTML(lotData: any) {
	const quickmove = lotData.quickmove ?? false;
	const modeled = lotData.modeled ?? false;
	const tour = lotData.tour ?? false;

	return quickmove || modeled || tour
		? ` 
    <hhds-taggroup slot="tags" style="--taggroup-left: 11px; --taggroup-bottom: 11px; --taggroup-gap: var(--spacing-spacer-6);">
      ${
				quickmove && !modeled
					? '<hhds-home-badge type="quickmove"></hhds-home-badge>'
					: ""
			}
      ${tour ? '<hhds-home-badge type="tour"></hhds-home-badge>' : ""}
      ${modeled ? '<hhds-home-badge type="modeled"></hhds-home-badge>' : ""} 
    </hhds-taggroup>  
  `
		: ``;
}

export function getModelHomeContent(apiResponse: LotApiResponse): string {
	const builderName = apiResponse.properties.builder.name;
	const badge = `${builderName}`;
	const heading = `Tour our model </br> homes today!`;
	const lotData = apiResponse.properties.lot;
	const phone = lotData.phone ?? "TBD";
	const email = lotData.email ?? "TBD";
	const address = lotData.address ?? "TBD";

	const tempAddress = "H8W7+49 Buckeye, Arizona, USA";
	const encodedAddress = encodeURIComponent(
		tempAddress.replace(/<br\s*\/?>/gi, " ")
	);
	const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;

	return `
  <hhds-card type="plans" modal="false">
    <hhds-richtext style="--richtext-padding: var(--spacing-spacer-12); --richtext-padding-md: var(--spacing-spacer-16); --richtext-display: block; flex: 1;">
      <p style="--richtext-color: var(--color-primary-darkgreen);" class="uppercase uppercase--01" >${badge}</p>
      <h3 class="heading heading--01" >${heading}</h3>
      <hhds-contact-information phone="${phone}" email="${email}" sales_office="${address}" directions="${directionsUrl}"></hhds-contact-information>
    </hhds-richtext>
  </hhds-card>
  `;
}
